<template>
  <div class="service">
    <div class="informations">
      <span class="label">
        {{ service.label }}
      </span>
      <span
        v-if="service.price"
        class="price-label">
        À partir de <span class="price">{{ price }}</span>
      </span>
    </div>
    <div class="radio">
      <el-radio
        v-model="serviceAction"
        label="replacement"
        @click.native.prevent="handleClick('replacement')">
        Executer
      </el-radio>
      <el-radio
        v-model="serviceAction"
        label="inspection"
        @click.native.prevent="handleClick('inspection')">
        Contrôler
      </el-radio>
    </div>
  </div>
</template>

<script>
import StringService from "@/services/StringService.js"

export default {
  name: "Service",
  props: {
    service: {
      type: Object,
      required: true
    },
    checkedServices: {
      type: Array,
      required: true
    }
  },
  data() {
    return { serviceAction: null }
  },
  computed: {
    price() {
      let currency = this.$store.state.checkin.appointment.appointment.workspace.country
      return StringService.currency(this.service.price, currency, false)
    }
  },
  watch: {
    checkedServices: {
      immediate: true,
      deep: true,
      handler(services) {
        this.handleCheck(services)
      }
    }
  },
  methods: {
    handleClick(action) {
      let payload = {
        value: this.service.id,
        type: this.service.type,
        action: null
      }

      if (this.serviceAction == action) {
        this.serviceAction = null
        this.$emit("update", payload)
        return
      }

      this.serviceAction = action
      payload.action = action
      this.$emit("update", payload)
    },
    handleCheck(services) {
      let servicesAction = {}

      services.forEach(service => {
        servicesAction[service.value] = service.action
      })

      if (!servicesAction[this.service.id]) {
        this.serviceAction = null
      }

      this.serviceAction = servicesAction[this.service.id]
    }
  }
}
</script>

<style lang="scss" scoped>
.service {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .informations {
    display: flex;
    flex-direction: column;
    .price-label {
      color: color(gray02);
      font-size: 14px;
      .price {
        font-weight: 500;
      }
    }
  }
  .label {
    font-weight: bold;
    font-size: 16px;
  }

  .radio {
    .el-radio__label {
      font-size: 12px;
    }
  }
}
</style>

<style lang="scss">
.service {
  .radio {
    .el-radio__label {
      font-size: 16px;
    }
  }
}
</style>
